import React, { useState, useEffect } from 'react'
import sha256 from 'js-sha256'
import axios from 'axios'
import {format} from 'date-fns'
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from './Spinner'
import OverlayLoader from '../modalPopups/overlayLoader'

export default function MemberLoginLogsSection(props) {

    const navigate = useNavigate();

    const hash = sha256(props.searchterm);
    const accessToken = localStorage.getItem("accessToken");

    let LogsUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/member-login-logs?hash=${hash}`;
    
    
    const [memberLogsResultStatus, setMemberLogsResultStatus] = useState(false);    
    const [memberLogsData, setMemberLogsData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [overLayPopupShow, setOverLayPopupShow] = useState(false);
    const [overLayPopupText, setOverLayPopupText] = useState('');
    

    const handleOverylayModalShowClose = (modalStatus,modalText) => {
        setOverLayPopupShow(modalStatus);
        setOverLayPopupText(modalText)
    }
    
  
  const fetchUrl = (URl) => {
		axios.get(URl, {				
			headers: {
				'Authorization': `Bearer ${accessToken}`
			},
		})
		.then(result => {
			//console.log("status"+result.data.status)      
      setIsLoading(false)
      handleOverylayModalShowClose(false,'')
			if(result.data.status === 'success')
			{        
        if(result.data.data.length > 0)
        {
          setMemberLogsResultStatus(true);
        }
        setMemberLogsData(result.data.data)
			}
		})
		.catch((error) => {
			// Error
      handleOverylayModalShowClose(false,'')
			if(error.response.status === 401)
			{
				localStorage.clear()
      	navigate("/login")
			}
		});
	}

    useEffect(() => {
        setIsLoading(true)
        handleOverylayModalShowClose(true,'Member Login Logs Loading... Please Wait')
		    fetchUrl(LogsUrl);// eslint-disable-next-line
	}, []);


  const getDeviceName = (device) => {
      if (device === 1) {
          return 'Desktop';
      }
      else if (device === 2) {
          return 'Tablet';
      }
      else if (device === 3) {
        return 'Mobile';
      }
      else {
        return 'Unknown';
      }
  }  

  return (
    <>
        <div className="app-wrapper">
          <div className="app-content pt-3 p-md-3 p-lg-4">
              <div className="container-xl">

                  <OverlayLoader
                      show={overLayPopupShow}
                      title=''
                      body={overLayPopupText}
                  />
                  <div className="app-content pt-3 mb-5">
                    {props.searchterm ? (
                      <h3>
                        Search: <code>{props.searchterm}</code>
                      </h3>
                    ) : (
                      <h3>There is no name in the query string</h3>
                    )}                
                  </div>

                  <h1 className="app-page-title mb-0">Members Logs</h1> <span className="text-danger">(Latest 30 Records Showing)</span>


                  <hr className="mb-4" />

                  
                  {!memberLogsResultStatus ? (
										<div className="alert alert-danger fade show ms-3">
											Member Login Logs Not Found
										</div>									
									) : (
                    

                      <div className="app-card app-card-orders-table mb-5">
                          <div className="app-card-body">
                              <div className="table-responsive">
                                  <table className="table table-hover table-bordered border-success">
                                      <thead>
                                          <tr>
                                              <th className="cell">Ip Address</th>
                                              <th className="cell">UserAgent</th>
                                              <th className="cell">Device</th>
                                              <th className="cell">DateTime</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                      {isLoading ? <tr><td colSpan={7}><LoadingSpinner loadingText='Fetching Member Login Logs' /></td></tr> : ''}                                      

                                      {memberLogsData && memberLogsData.map((memberLogsDataResults, i) => {

                                        //totalPurchase = (parseFloat(totalPurchase) + parseFloat(order.productInfo.price));

                                        let formattedLogDate = format(new Date(memberLogsDataResults.dateTime),"MMM dd, y hh:mm:ss")

                                        let deviceName = getDeviceName(memberLogsDataResults.device);

                                            return (
                                                <tr key={i}>
                                                    <td>{memberLogsDataResults.ipAddres}</td>
                                                    <td>{memberLogsDataResults.userAgent}</td>
                                                    <td>{deviceName}</td>
                                                    <td>{formattedLogDate}</td>
                                                </tr>
                                            )
                                        })

                                      }
                                      </tbody>
                                  </table>                                  
                              </div>
                          </div>
                      </div>
                  )}
              </div>     
          </div>
      </div>
    </>
    )
}